module.exports = __webpack_public_path__ + "img/1x.c7a454d.jpg";